import {
  SCHEDULE_PREVIEW_DURATIONS_REQUEST,
  SCHEDULE_PREVIEW_DURATIONS_SUCCESS,
  SCHEDULE_PREVIEW_DURATIONS_FAILURE,
} from 'actions';

/**
 * Stores the result of the preview-durations endpoint.
 *
 * data shape: {
 *   [categoryId]: {
 *     durationMinutes:  number,
 *     participantCount: number,
 *     roundCount:       number,
 *     debugRounds:      { [roundKey]: number },
 *     hasDrawData:      boolean,
 *   }
 * }
 */
const initialState = {
  data: null,
  isFetching: false,
};

export const durationPreviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCHEDULE_PREVIEW_DURATIONS_REQUEST:
      return { ...state, isFetching: true };

    case SCHEDULE_PREVIEW_DURATIONS_SUCCESS:
      return { isFetching: false, data: action.data };

    case SCHEDULE_PREVIEW_DURATIONS_FAILURE:
      return { ...state, isFetching: false };

    default:
      return state;
  }
};
